import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NePowerPointvg } from './NePowerPointSvg'

export const NePowerPointIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NePowerPointvg} {...props} />
}
